import styled from 'styled-components';

export const StyledSinglePage = styled.div`
  position: relative;
  height: 100%;
`;